import React from "react";
import { Link } from "react-router-dom";
import { formatValue } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function WaiversTab({ waivers }) {
  return (
    <div data-testid="ptab-content-waivers">
      <p className="text-sm text-[var(--text-2)] mb-3">High-value assets sitting on the waiver wire across your leagues.</p>
      {waivers === null ? (
        <div className="card-bordered p-10 flex justify-center"><Loader2 className="w-5 h-5 spin text-[var(--accent)]" /></div>
      ) : waivers.length === 0 ? (
        <div className="card-bordered p-8 text-center text-sm text-[var(--text-3)]">No notable free agents found.</div>
      ) : (
        <div className="card-bordered overflow-hidden">
          {waivers.map(w => (
            <div key={w.player_id} className="flex items-center justify-between px-4 py-2.5 text-sm border-b border-[var(--border)] last:border-0 hover:bg-white/5" data-testid={`waiver-${w.player_id}`}>
              <div className="min-w-0">
                <Link to={`/app/players/${w.player_id}`} className="hover:text-[var(--accent)]">{w.name}</Link>
                <span className="text-[10px] tracking-widest text-[var(--text-3)] ml-2">{w.position} · {w.team}</span>
              </div>
              <div className="flex items-center gap-4 shrink-0">
                <span className="text-xs text-[var(--text-2)]">FA in {w.available_in} league{w.available_in !== 1 ? "s" : ""}</span>
                <span className="font-mono text-[var(--accent)]">{formatValue(w.value)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
